import React from "react";
import { Row, Col, Card } from "antd";
import AccountRemain from "./card/accountRemain";
import IncomeSmartbilling from "./panel/incomeSB";
import SbIncomeDetail from "./panel/incomeSbDetail";

const AdminDashboard = () => {
  return (
    <div style={{ padding: 24 }}>
      <Row gutter={16}>
        <Col span={24}>
          <AccountRemain />
        </Col>
        <Col span={24}>
          <IncomeSmartbilling />
        </Col>
        <Col span={24}>
          <SbIncomeDetail />
        </Col>
      </Row>
    </div>
  );
};

export default AdminDashboard;
